<template>
  <div>
    <div>
      <v-card class="pa-2">
        <v-layout row wrap class="ma-0">
          <v-flex xs7>
            <div style="font-weight: 800">
              #{{ ticket.id }} {{ ticket.subject }}
              <span v-if="ticket.cold_case"
                ><v-chip label small dark color="#2a9ba8" tile>COLD CASE</v-chip></span
              >
            </div></v-flex
          >
          <v-flex xs5>
            <div class="text-xs-right">
              <v-chip
                v-if="ticket.channel == 'facebook'"
                class="chipcustomfacebook"
                dark
                color="#3b5998
                "
              >
                <em class="fab fa-facebook-square mr-2" />{{ ticket.customer_page_name }}</v-chip
              >
              <v-chip
                v-else-if="ticket.channel == 'line'"
                class="chipcustomline"
                dark
                color="#00c300
                "
              >
                <em class="fab fa-line mr-2" />{{ ticket.customer_page_name }}</v-chip
              >
              <v-btn
                color="primary"
                outline
                small
                icon
                @click="handleShowHistory(ticket.id)"
                :loading="loadingHistory"
              >
                <em class="fas fa-history" />
              </v-btn>
              <v-btn @click="goToLivechat(ticket, ticket.app)" color="primary" outline small icon>
                <em class="fas fa-comments" />
              </v-btn>
              <TicketEdit
                v-if="ticket && !loadingAgentData"
                :type="'edit'"
                :ref="`editticket_${ticket.id}`"
                v-model="ticket"
                :key="ticket.id"
                @editTicket="onEditTicket"
              ></TicketEdit>
            </div>
          </v-flex>
          <v-flex xs6>
            <div style="display: flex">
              <div>
                <v-avatar size="90px">
                  <v-img :src="ticket.profile_pic"></v-img>
                </v-avatar>
              </div>
              <div class="ml-3">
                <div style="font-size: small; color: #909090">
                  {{ ticket.first_name }} {{ ticket.last_name }}
                </div>

                <div style="font-size: 11px; color: grey">
                  <span>Date created: {{ ticket.starttime | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                  <div>End time: {{ ticket.endtime | DateFormat('DD/MM/YYYY HH:mm') }}</div>
                  <div>
                    Time closed:
                    <template v-if="ticket.starttime && ticket.endtime">
                      {{
                        addDurationUnit(
                          durationTime(
                            ticket.reasign_date ? ticket.reasign_date : ticket.starttime,
                            ticket.endtime
                          )
                        )
                      }}
                    </template>
                    <template v-else> - </template>
                  </div>
                  <div>
                    <span v-if="ticket.adminupdatetime" style="padding-right: 2px">
                      Agent responded: {{ dayLeft(ticket.adminupdatetime) }}
                    </span>
                    <span v-else>Pending for {{ dayLeft(ticket.starttime) }}</span>
                  </div>
                  <div>Due date: {{ ticket.duedate | DateFormat('DD/MM/YYYY HH:mm') }}</div>
                </div>
                <div v-if="editloading" class="pt-2 text-xs-center">
                  <v-progress-circular
                    size="20"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
                <div v-else class="my-3" style="display: flex">
                  <div class="mr-2">
                    <DropdownMenu
                      :noicon="true"
                      v-model="ticket.priority"
                      @change="updateTicket"
                      :options="priorityOptions"
                    >
                      <span
                        class="px-3 py-1"
                        style="
                          text-transform: capitalized;
                          white-space: nowrap;
                          background-color: rgb(233 233 233);
                          border-radius: 6px;
                          border: 1px solid #b9b9b9;
                        "
                      >
                        <i
                          :style="{ color: priorityColor(ticket.priority) }"
                          class="fas fa-circle mr-2"
                        />

                        <span style="text-transform: capitalized">
                          {{ ticket.priority | toCapitalized }}
                        </span>
                      </span>
                    </DropdownMenu>
                  </div>
                  <div>
                    <DropdownMenu
                      @change="updateTicket"
                      :noicon="true"
                      v-model="ticket.status"
                      :options="statusOptions"
                    >
                      <span
                        class="px-3 py-1"
                        style="
                          white-space: nowrap;
                          background-color: rgb(233 233 233);
                          border-radius: 6px;
                          border: 1px solid #b9b9b9;
                          text-transform: capitalized;
                        "
                      >
                        {{ ticket.status | toCapitalized }}
                      </span>
                    </DropdownMenu>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs6>
            <div
              style="
                word-break: break-word;
                height: 38.8px !important;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                color: grey;
                font-size: 13px;
              "
            >
              {{ ticket.details }}
            </div>
            <v-layout row wrap class="ma-0">
              <v-flex xs6>
                <span class="groupticket2" @click="opentransferdialog">
                  <span>
                    <em class="fas fa-users mr-2" />{{ getGroup ? getGroup.groupname : '-' }}
                    <span v-if="getSubGroup"> / {{ getSubGroup.subgroupname }} </span>
                  </span>
                  <br />
                  <span><em class="fas fa-user-tie mr-2" />{{ getAgentName.name }}</span>
                </span>
              </v-flex>
              <v-flex xs6>
                <v-chip
                  v-for="(tag, k) in tags"
                  :key="k"
                  style="
                    background-color: rgb(59, 89, 152);
                    border-color: rgb(59, 89, 152);
                    border-radius: 5px;
                    height: 24px;
                  "
                  outline
                  >{{ tag }}</v-chip
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </div>
    <v-dialog v-model="transferdialog" persistent width="600px">
      <v-card class="pa-3" style="position: relative">
        <div style="position: absolute; right: 0px; top: 0px">
          <v-btn @click="transferdialog = false" icon small>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div style="font-size: 20px; font-weight: bold">
          <em class="fas fa-exchange-alt" />
          Transfer ticket
        </div>
        <v-layout row wrap>
          <v-flex
            xs6
            sm6
            class="form-control px-1 pb-2"
            :class="{ 'has-error': errors.has('group') }"
          >
            <div class="caption mb-1 mt-2">Group *</div>
            <!-- <div class="primary--text">{{ transfer.group.groupname }}</div> -->
            <!-- :options="filteredAgentGroup" -->
            <multiselect
              v-model="transfer.group"
              :options="agentGroup"
              track-by="groupname"
              label="groupname"
              :searchable="true"
              selectLabel
              selectedLabel
              v-validate="'required'"
              deselect-label
              @input="onChangeGroup"
              :data-vv-as="$t('Group')"
              name="group"
            ></multiselect>
            <p class="text-error" v-if="errors.has('group')">{{ errors.first('group') }}</p>
          </v-flex>
          <v-flex xs6 sm6 class="form-control px-1 pb-2">
            <div class="caption mb-1 mt-2">Subgroup</div>
            <v-layout>
              <multiselect
                v-model="transfer.subgroup"
                :options="filterSubGroup"
                track-by="subgroupname"
                label="subgroupname"
                :searchable="true"
                selectLabel
                selectedLabel
                @input="onChangeSubGroup"
                deselect-label
              ></multiselect>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            sm12
            class="form-control px-1 pb-2"
            :class="{ 'has-error': errors.has('group') }"
          >
            <div class="caption mb-1 mt-2">Assigned to</div>
            <v-layout>
              <!-- v-validate="'required'" 
                @input="onAssignInput"
              -->
              <multiselect
                v-model="transfer.assignedTo"
                :options="filterAgents"
                track-by="name"
                label="name"
                :searchable="true"
                name="agent"
                selectLabel
                selectedLabel
                deselect-label
              ></multiselect>
            </v-layout>
            <p class="text-error" v-if="errors.has('agent')">{{ errors.first('agent') }}</p>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn :loading="transferloading" @click="onTransferTicket" color="primary"
            >Transfer</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showHistory" v-if="historyData" persistent width="800px">
      <HistoryStatus
        v-model="historyData"
        v-if="showHistory"
        @close="handleCloseHistory"
      ></HistoryStatus>
    </v-dialog>
  </div>
</template>

<script>
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import TicketEdit from './TicketEdit.vue'
import Multiselect from 'vue-multiselect'
import HistoryStatus from './HistoryStatus.vue'
import api from '@/api'
export default {
  props: {
    ticket: {
      type: Object,
      default: null
    }
  },
  components: {
    DropdownMenu,
    TicketEdit,
    Multiselect,
    HistoryStatus
  },
  computed: {
    loadingAgentData() {
      return this.loadingAgentGroup || this.loadingAgentSubGroup || this.loadingAgent
    },
    filterSubGroup() {
      if (this.transfer.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.transfer.group.id
        })
      } else {
        return []
      }
    },
    filterAgents() {
      if (this.transfer.group) {
        var agents = this.agent.filter((el) => {
          return el.admingroupid == this.transfer.group.id
        })
        if (this.transfer.subgroup) {
          agents = agents.filter((el) => {
            return el.adminsubgroupid == this.transfer.subgroup.id
          })
        }
        return agents
      } else {
        return this.agent ? this.agent : []
      }
    },
    ...mapGetters({
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      agent: 'getAgent',
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      loadingAgent: 'getLoadingAgent'
    }),
    filteredAgentGroup() {
      if (this.agentGroup && this.agentGroup.length) {
        return this.agentGroup.filter((el) => ['Agent', 'Supervisor'].includes(el.groupname))
      } else {
        return []
      }
    },
    getGroup() {
      if (this.ticket.assigngroupid && this.agentGroup && this.agentGroup.length) {
        return this.agentGroup.find((el) => el.id == this.ticket.assigngroupid)
      } else return ''
    },
    getSubGroup() {
      if (this.ticket.assignsubgroupid && this.agentSubGroup && this.agentSubGroup.length) {
        return this.agentSubGroup.find((el) => el.id == this.ticket.assignsubgroupid)
      } else return ''
    },
    getAgentName() {
      if (this.ticket.adminid && this.agent && this.agent.length) {
        return this.agent.find((el) => el.adminid == this.ticket.adminid)
      } else return ''
    },
    tags() {
      if (this.ticket.tags) {
        return this.ticket.tags.split(',')
      } else return []
    }
  },
  data() {
    return {
      transferloading: false,
      transfer: {
        group: '',
        subgroup: '',
        assignedTo: ''
      },
      transferdialog: false,
      showEdit: false,
      editloading: false,
      priority: 'Low',
      status: 'Pending',
      priorityOptions: ['low', 'medium', 'high'],
      statusOptions: ['Pending', 'Answered', 'Cancel', 'Closed'],
      showHistory: false,
      historyData: null,
      loadingHistory: false
    }
  },

  methods: {
    goToLivechat: function (user, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app,
          pageid: this.ticket.pageid
        }
      })
      window.open(routeData.href, '_blank')
    },
    async onTransferTicket() {
      var isValid = await this.$validator.validate()

      if (isValid) {
        var data = {
          pageid: this.selectedBot.pageid,
          transferGroupId: this.transfer.group.id,
          ticketId: this.ticket.id
        }

        if (this.transfer.subgroup) {
          Object.assign(data, { transferSubGroupId: this.transfer.subgroup.id })
        }
        // if (this.transfer.group) {
        //   Object.assign(data, { transferGroupId: this.transfer.group.id })
        // }

        if (this.transfer.assignedTo) {
          Object.assign(data, { transferAdminId: this.transfer.assignedTo.adminid })
        }

        this.transferloading = true
        api.ticket2TransferTicket(data, (err, response) => {
          this.transferloading = false
          this.transferdialog = false
          if (response.responsecode == 200) {
            this.$emit('ontransfer')
          }
        })
      }
    },
    opentransferdialog() {
      this.transfer = { group: '', subgroup: '', assignedTo: '' }
      // this.$set(
      //   this.transfer,
      //   'group',
      //   this.agentGroup.find((el) => el.groupname == 'Agent')
      // )
      this.transferdialog = true
    },
    onAssignInput(val) {
      if (val) {
        this.transfer.group = this.agentGroup.find((el) => el.id == val.admingroupid)
        this.transfer.subgroup = this.agentSubGroup.find((el) => el.id == val.adminsubgroupid)
      }
    },
    async onChangeSubGroup(val) {
      this.transfer.assignedTo = null
    },
    async onChangeGroup(val) {
      this.transfer.subgroup = null
      this.transfer.assignedTo = null
    },
    async updateTicket() {
      var data = {
        ...this.ticket,
        pageid: this.selectedBot.pageid, // required
        ticketId: this.ticket.id, // required
        priority: this.ticket.priority
      }
      this.editloading = true
      var response = await this.editTicket(data)
      this.editloading = false
      if (response.responsecode == 200) {
      }
    },
    editTicket(data) {
      return new Promise((resolve, reject) => {
        var request = data
        api.ticket2UpdateTicket(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    onEditTicket(ticket) {
      var vm = this
      this.$emit('update:ticket', { ...vm.ticket, ...ticket })
    },
    async handleShowHistory(id) {
      const vm = this
      vm.loadingHistory = true
      vm.showHistory = true
      await vm.handleGetTicketHistory(id)
    },
    handleCloseHistory() {
      this.historyData = null
      this.showHistory = false
    },
    async handleGetTicketHistory(id) {
      const vm = this
      try {
        const response = await api.ticket2GetTicketHistory({
          pageId: vm.selectedBot.pageid,
          ticketId: id
        })

        if (response) {
          vm.historyData = response.history
          vm.loadingHistory = false
        }
      } catch (error) {
        vm.loadingHistory = false
        console.error(error)
        return
      }
    },
    dayLeft: function (replytime) {
      var lastreply = moment(replytime)
      var currentDate = moment()

      var time = ''
      if (currentDate.diff(lastreply, 'days') > 0) {
        time = lastreply.format('DD MMM YYYY')
      } else if (currentDate.diff(lastreply, 'hours') > 0) {
        time = currentDate.diff(lastreply, 'hours')
        time += ' ' + 'Hours'
      } else if (currentDate.diff(lastreply, 'minutes') > 0) {
        time = currentDate.diff(lastreply, 'minutes')
        time += ' ' + 'Minutes'
      } else if (currentDate.diff(lastreply, 'seconds') > 0) {
        time = currentDate.diff(lastreply, 'seconds')
        time += ' ' + 'Seconds'
      }
      return time
    },
    priorityColor(item) {
      if (item.toLowerCase() == 'low') {
        return 'green'
      } else if (item.toLowerCase() == 'medium') {
        return 'orange'
      } else if (item.toLowerCase() == 'high') {
        return 'red'
      }
    },
    durationTime(start, end) {
      var startTime = start
      var endTime = end
      var minutes = moment
        .duration(moment(endTime, 'YYYY/MM/DD HH:mm').diff(moment(startTime, 'YYYY/MM/DD HH:mm')))
        .asMinutes()
        .toFixed(2)
      return minutes
    },
    addDurationUnit(minutes) {
      return moment.duration(parseFloat(minutes), 'minutes').format('h [hrs], m [min]')
    }
  },
  filters: {
    toCapitalized(value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>

<style>
.chipcustomfacebook {
  background-color: rgb(59, 89, 152) !important;
  border-color: rgb(59, 89, 152) !important;
  border-radius: 5px !important;
  height: 24px !important;
}
.chipcustomline {
  background-color: #00c300 !important;
  border-color: #00c300 !important;
  border-radius: 5px !important;
  height: 24px !important;
}
.groupticket2 {
  cursor: pointer;
  color: darkgrey;
}
.groupticket2:hover {
  color: rgb(94, 94, 94);
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket2/management/TicketItem.vue